import { IErrorDto, ITherapist } from './types';

export function typedEntries<T extends object>(obj: T): [keyof T, T[keyof T]][] {
  return Object.entries(obj) as [keyof T, T[keyof T]][];
}

export function TypeGuard<T>(input: unknown | undefined, fieldNames: Array<keyof T>): input is T {
  return input ? fieldNames.every(field => Object.prototype.hasOwnProperty.call(input, field)) : false;
}

export function IErrorDtoTypeGuard(input: unknown): input is IErrorDto {
  const fields: Array<keyof IErrorDto> = [
    'error',
  ];
  return TypeGuard<IErrorDto>(input, fields);
}

export function ITherapistTypeGuard(input: unknown): input is ITherapist {
  const fields: Array<keyof ITherapist> = [
    'telephone',
    'approved',
    'isCallAllowed',
    'country',
  ];
  return TypeGuard<ITherapist>(input, fields);
}
